<mat-list-item (click)="markAsReaded()">
  <mat-icon mat-list-icon *ngIf="notification.readed">mark_email_read</mat-icon>
  <mat-icon mat-list-icon *ngIf="!notification.readed">mark_email_unread</mat-icon>
  <div mat-line *ngIf="!notification.readed" class="title">{{ notification.subject }}</div>
  <div mat-line *ngIf="notification.readed">{{ notification.subject }}</div>
  <div mat-line>{{ notification.body }}</div>
  <div mat-line class="small">{{ notification.creationTime ? (notification.creationTime | date: "dd/MM/yyyy HH:mm") : '' }}</div>
</mat-list-item>
